import React, { useEffect, useRef } from 'react'
import { Button, Toast } from '@ow/comps'
import { useDetailStore, useTbViewStore } from '@vt/hooks'
import { get, pick } from 'lodash-es'
import Confirm from '../confirm'
import Detail from '../tables/details/detail'
import BatchAdd from './batchAdd'
import { useDefsInjector } from './hooks/defsInjector'
// import Collector from '../tables/triggers/collector'

const Attribute = function ({ title, clickedId, type }) {
  const {
    setOriginalData,
    setCurrentData,
    currentData,
    setEditableSlugs,
    editableSlugs,
  } = useDetailStore((state) =>
    pick(state, [
      'setOriginalData',
      'setCurrentData',
      'currentData',
      'setEditableSlugs',
      'editableSlugs',
    ])
  )
  const {
    fetchTbDataById,
    updateTbData,
    fields,
    editorConfig,
    destroyTbData,
    setClickedInfo,
    tbData,
    setTbData,
    ditto,
  } = useTbViewStore((state) =>
    pick(state, [
      'fetchTbDataById',
      'updateTbData',
      'fields',
      'editorConfig',
      'destroyTbData',
      'setClickedInfo',
      'tbData',
      'setTbData',
      'ditto',
    ])
  )

  const formRef = useRef(null)

  const getEditorSlugs = () => {
    if (get(editorConfig, 'editorSlugs', null)) {
      return editorConfig.editorSlugs
    }
    return fields
      .filter((field) => {
        return field.group !== 'system' && !field.hiddenWhenCreate
      })
      .map((field) => {
        return field.slug
      })
  }

  const getDataDetail = () => {
    fetchTbDataById(clickedId).then((res) => {
      setOriginalData(res.originalData)
      setCurrentData(res.currentData)
    })
  }
  useEffect(() => {
    getDataDetail()
    setEditableSlugs([])
  }, [clickedId])

  useDefsInjector(true)

  const editMode = editableSlugs.length !== 0

  return (
    <div>
      <div className="absolute" style={{ right: '20px', top: '15px' }}>
        <div className="flex">
          {editMode ? (
            <div className="flex items-center gap-2">
              <Button
                type="primary"
                onClick={() => {
                  if (formRef && formRef.current) {
                    formRef.current.trigger().then((tr) => {
                      if (tr) {
                        updateTbData({
                          ...formRef.current.getValues(),
                          objectId: currentData.objectId,
                        })
                          .then(() => {
                            setEditableSlugs([])
                            getDataDetail()
                            ditto.cleanTbDataCache()
                          })
                          .catch((err) => {
                            Toast.error({
                              title: '保存失败',
                              description: err.message,
                            })
                          })
                      }
                    })
                  }
                }}
              >
                保存
              </Button>
              <Button
                stroke
                onClick={() => {
                  setEditableSlugs([])
                  if (formRef.current) {
                    formRef.current.reset()
                  }
                }}
              >
                取消
              </Button>
            </div>
          ) : (
            <div className="flex gap-3">
              <BatchAdd
                title={title}
                type={type}
                refreshTreeData={(data) => {
                  setTbData(tbData.concat(data))
                }}
                isAddChild
              >
                <Button stroke>添加下级</Button>
              </BatchAdd>
              <Button
                stroke
                onClick={() => {
                  setEditableSlugs(getEditorSlugs())
                }}
              >
                编辑
              </Button>
              <Button
                stroke
                onClick={() => {
                  ditto
                    .toggleNodeEnabled({
                      objectId: currentData.objectId,
                      disable: !currentData.isDisableNode,
                    })
                    .then(() => {
                      getDataDetail()
                      ditto.cleanTbDataCache()
                    })
                }}
              >
                {currentData && currentData.isDisableNode ? '启用' : '禁用'}
              </Button>
              <Confirm
                title={`确定删除当前${title}？${title}删除后不可恢复`}
                onConfirm={(close) => {
                  destroyTbData(clickedId)
                    .then(() => {
                      Toast.success({
                        title: '删除成功',
                      })
                      setClickedInfo({})
                      ditto.cleanTbDataCache()
                    })
                    .catch((err) => {
                      Toast.error({
                        title: '删除失败',
                        description: err.message,
                      })
                    })
                  close()
                }}
              >
                <Button stroke>删除</Button>
              </Confirm>
            </div>
          )}
        </div>
      </div>
      <div className="overflow-y-auto">
        {currentData && <Detail ref={formRef} />}
      </div>
    </div>
  )
}

export default Attribute
